<p>hl-assign-defaults works!</p>
